import assetPath from '/app/xinglets/business-solutions/page/src/assets/marketing.webp';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')